import React from "react";
import "./SocialWorkPage.css";
import Banner from "../Component/social activity.jpg"; // 🖼️ replace with your actual banner image

const SocialWorkPage = () => {
  return (
    <div className="social-page">
      {/* ✅ Banner Section */}
      <div className="social-banner">
        <img src={Banner} alt="Social Work at CPIT" className="banner-img" />
      </div>

      {/* ✅ Content Section */}
      <div className="social-content">
        <h2>Social Work Initiatives by CPIT Institute</h2>
        <p>
          The <strong>Career Point of Information Technology (CPIT)</strong> believes that education
          is not only about academics but also about building a responsible and compassionate society.
          Our institute regularly organizes and participates in social welfare programs to serve the
          community and create positive change.
        </p>

        <h2>Our Mission</h2>
        <p>
          The mission of CPIT’s social work programs is to inspire students to actively participate
          in humanitarian and environmental causes. We aim to instill empathy, leadership, and a
          sense of civic responsibility among our students.
        </p>

        <h2>Major Social Work Activities</h2>
        <ul>
          <li>🌱 <strong>Tree Plantation Drives</strong> — Encouraging environmental awareness and a greener campus.</li>
          <li>❤️ <strong>Blood Donation Camps</strong> — Organized in collaboration with local hospitals and NGOs.</li>
          <li>🩺 <strong>Health Awareness Programs</strong> — Conducted sessions on hygiene, nutrition, and mental well-being.</li>
          <li>📚 <strong>Education Support</strong> — Volunteers assist underprivileged children with learning materials and classes.</li>
          <li>♻️ <strong>Cleanliness Campaigns</strong> — “Swachh Campus, Swachh Bharat” initiatives within and around CPIT.</li>
          <li>🧥 <strong>Winter Clothing Distribution</strong> — Providing warm clothes to the needy during cold seasons.</li>
        </ul>

        <h2>Impact of Our Initiatives</h2>
        <p>
          Through these activities, CPIT has reached hundreds of individuals in nearby communities.
          Our students learn the values of teamwork, empathy, and leadership while directly
          contributing to social betterment. Every effort, big or small, counts in creating
          a sustainable and compassionate future.
        </p>

        <h2>Future Plans</h2>
        <p>
          CPIT aims to expand its social welfare reach by partnering with NGOs, government bodies,
          and community leaders. Upcoming plans include <strong>digital literacy workshops, women
          empowerment programs, and rural health camps</strong>.
        </p>

        <h2>Conclusion</h2>
        <p>
          The <strong>Social Work Cell of CPIT</strong> continues to uphold the spirit of humanity
          and service. By integrating social responsibility with education, CPIT nurtures not only
          skilled professionals but also compassionate citizens who are ready to make a difference.
        </p>
      </div>
    </div>
  );
};

export default SocialWorkPage;
